import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=318988af"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=318988af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports